module.exports = __webpack_public_path__ + "feec175db5243b453b9dc5f3fa3e062c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/images/ic_classroom_active_24.svg
// module id = 1088
// module chunks = 3